"use strict";
exports.__esModule = true;
exports.toNumber = void 0;
var toNumber = function (data, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.min, min = _c === void 0 ? -Infinity : _c, _d = _b.max, max = _d === void 0 ? Infinity : _d, defaultValue = _b.defaultValue;
    if (!data && typeof data !== 'number') {
        return defaultValue;
    }
    return Math.max(Math.min(Number(data), max), min);
};
exports.toNumber = toNumber;
//# sourceMappingURL=number.js.map